export default {
  filters: {
    formatNumber: (number, maximumFractionDigits = 2) => {
      const parsedNumber = parseFloat(number);
      if (Number.isNaN(parsedNumber)) {
        return number;
      }
      const options = { maximumFractionDigits, minimumFractionDigits: 2 };
      return parsedNumber.toLocaleString(undefined, options);
    },
    roundNumber(number, decimalPlaces = 2) {
      return Number(
        `${Math.round(
          parseFloat(`${number}e${decimalPlaces}`),
        )}e-${decimalPlaces}`,
      );
    },
    numberToDots(number) {
      return parseFloat(
        number.toString()
          .replace(',', '.')
          .replace(' ', ''),
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/numberMixin.js